// @flow
import { path } from 'ramda';

import i18n from 'app/i18n';


const putOnFoodErrorProcessing: (whom: string) => (error: Error) => string = (
  (whom: string) => (error: Error): string => {
    const errCode = path(['response', 'status'], error);
    const message = path(['response', 'data', 'message'], error);

    if (errCode === 403) {
      if (message === 'bad order status') {
        return i18n.t('cafeteria:order_request_sales_put_on_food_bad_order_status_error', { whom });
      }
      if (message === 'order has been changed') {
        return i18n.t('cafeteria:order_request_sales_put_on_food_order_has_been_changed_error', { whom });
      }
      if (message === 'order in queue') {
        return i18n.t('cafeteria:order_request_sales_put_on_food_order_in_queue_error', { whom });
      }
      if (message === 'time expired') {
        return i18n.t('cafeteria:order_request_sales_put_on_food_time_expired_error', { whom });
      }
    }
    return i18n.t('cafeteria:order_request_sales_put_on_food_submit_error', { whom });
  }
);

export default putOnFoodErrorProcessing;
